import type { SaleBadge } from "@lib/wrappers/algolia/types";

/**
 * Checks if a sale badge should be displayed based on the current date and badge validity period
 * @param hasDiscount - Indicates if the product has a discount
 * @param saleBadge - The sale badge information
 * @returns The sale badge if it's valid and within the time period, undefined otherwise
 */
export const getValidSaleBadge = (saleBadge: SaleBadge) => {
    if (!saleBadge) {
        return undefined;
    }

    const now = new Date();
    const from = new Date(saleBadge.from);
    const until = new Date(saleBadge.until);

    return now >= from && now <= until ? saleBadge : undefined;
};
